import { EnvelopeOfListOfString } from '@/api/klip-api.proxy';
import {defineComponent, onMounted, ref, useTemplateRef, watch} from 'vue';
import {useKlipApiProxy} from '@/plugins/proxy-client';
import * as yup from 'yup';
import {
    klValidateYup,
    klValidationField,
} from '@/app/shared/components/kl-form-fields/kl-field-validation-util';
import {find, forEach} from 'lodash-es';

export const createTagsSchema = () => yup.array(yup.string()).kl_tags().label('Tags');

export default defineComponent({
    compatConfig: {
        MODE: 3,
    },
    name: 'KlTags',
    emits: ['update:modelValue', 'add-tag', 'remove-tag'],
    props: {
        modelValue: { type: Array<string>, required: true },
        modDisabled: { type: Boolean, required: false, default: false },
        formPath: { type: String, required: true },
    },
    setup(props, { emit, attrs }) {

        const schema = createTagsSchema();
        const tagsField = klValidationField(schema, props.formPath);

        const tags = ref<string[]>(props.modelValue);
        const tagSuggestions = ref<string[]>([]);

        const handleTagCreate = async (option: { label: string, value: string }) => {
            const isValid = await _validateTags([option.value]);
            if (!isValid) {
                return false;
            }

            return option;
        }

        const onSelect = async (tag: string) => {
            // ?protect against invalid tagSuggestions?
            const isValid = await _validateTags([tag]);
            if (!isValid) {
                return;
            }

            emit('add-tag', tag);
        }

        const _validateTags = async (newTags: string[]): Promise<boolean> => {
            const validationResult = await klValidateYup(newTags, schema);
            tagsField.field.setErrors(validationResult.errors);
            return validationResult.valid;
        }

        watch(
            tags,
            (newTags: string[], oldTags: string[]) => {
                // update validation message
                _validateTags(newTags).then();

                // emit remove-tag events (clear will remove all tags)
                forEach(oldTags, (ot: string) => {
                    const isRemoved = newTags.indexOf(ot) === -1;
                    if (isRemoved) {
                        emit('remove-tag', ot);
                    }
                });

                // emit update always (also when invalid)
                emit('update:modelValue', newTags);
            },
            { immediate: false, deep: true });


        onMounted(() => {
            tags.value = props.modelValue;

            // update possible tags
            useKlipApiProxy().mri_GetTags().then((response: EnvelopeOfListOfString) => {
                tagSuggestions.value = response.result;
            });
        });

        return {
            tags,
            tagSuggestions,
            tagsField,

            onSelect,
            handleTagCreate,
        }
    }
})
